(function () {
  var FADE_OUT_MS = 220;
  var NAVIGATION_FAILSAFE_MS = 1500;

  var loader = null;
  var navigationHideTimer = null;
  var visible = false;

  function isModifiedNavigation(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented;
  }

  function isRegularNavigationLink(link) {
    if (!link) return false;
    if (link.target === '_blank' || link.hasAttribute('download')) return false;

    var href = link.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return false;

    try {
      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return false;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return false;
    } catch (error) {
      return false;
    }

    return true;
  }

  function setNavigationFailsafe() {
    if (navigationHideTimer) {
      window.clearTimeout(navigationHideTimer);
    }

    navigationHideTimer = window.setTimeout(function () {
      if (document.visibilityState === 'visible') {
        hideLoader();
      }
    }, NAVIGATION_FAILSAFE_MS);
  }

  function showLoader() {
    if (!loader || visible) return;
    visible = true;
    loader.setAttribute('aria-hidden', 'false');
    loader.classList.add('page-loader--visible');
    loader.classList.remove('page-loader--hidden');
    document.body.classList.add('page-loader-active');
    setNavigationFailsafe();
  }

  function hideLoader() {
    if (!loader) return;
    if (navigationHideTimer) {
      window.clearTimeout(navigationHideTimer);
      navigationHideTimer = null;
    }

    if (!visible) {
      loader.classList.remove('page-loader--visible');
      loader.classList.add('page-loader--hidden');
      document.body.classList.remove('page-loader-active');
      loader.setAttribute('aria-hidden', 'true');
      return;
    }

    loader.classList.remove('page-loader--visible');
    loader.classList.add('page-loader--hidden');
    document.body.classList.remove('page-loader-active');

    window.setTimeout(function () {
      loader.setAttribute('aria-hidden', 'true');
    }, FADE_OUT_MS);
  }

  function initLoader() {
    loader = document.getElementById('PageLoader');
    if (!loader) return;

    loader.setAttribute('aria-hidden', 'true');
    loader.classList.add('page-loader--hidden');

    document.addEventListener(
      'click',
      function (event) {
        if (isModifiedNavigation(event)) return;

        var link = event.target.closest('a');
        if (!isRegularNavigationLink(link)) return;
        showLoader();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        if (event.defaultPrevented) return;
        var form = event.target;
        if (!form || form.method.toLowerCase() === 'dialog') return;
        showLoader();
      },
      true
    );

    window.addEventListener('beforeunload', showLoader);
    window.addEventListener('load', hideLoader, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoader, { once: true });
  } else {
    initLoader();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) hideLoader();
  });
})();
